var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4165 11.6667V8.16675H9.9165",
    stroke: "#333C43",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.583496 2.33325V5.83325H4.0835",
    stroke: "#333C43",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9527 5.25008C11.6568 4.41404 11.154 3.66657 10.4911 3.07741C9.82828 2.48825 9.02698 2.07661 8.162 1.8809C7.29702 1.68519 6.39656 1.71178 5.54464 1.9582C4.69271 2.20462 3.9171 2.66283 3.29016 3.29008L0.583496 5.83342M13.4168 8.16675L10.7102 10.7101C10.0832 11.3373 9.30761 11.7955 8.45569 12.042C7.60377 12.2884 6.70331 12.315 5.83833 12.1193C4.97335 11.9236 4.17205 11.5119 3.50919 10.9228C2.84632 10.3336 2.34351 9.58613 2.04766 8.75009",
    stroke: "#333C43",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.3ecf7af6f10a427143a018c0b4ae5a7d.svg";
export { ForwardRef as ReactComponent };